import axios from "axios";
import routes from "./routes";
import { getCurrentFbo, getUserToken, removeCurrentFbo, removeFCMToken, removeUserToken } from "./tokenHandler";

const baseUrl = import.meta.env.VITE_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    AppVersion: '1.0.0',
    AppType: 'web',
    DeviceType: 'web',
  },
});

// Add request interceptor to dynamically set the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getUserToken();
    const deviceId = localStorage.getItem('inspection_deviceId');
    const savedLanguage = localStorage.getItem('language');
    const currentFbo = getCurrentFbo() || null;

    if (savedLanguage) {
      config.headers['Accept-Language'] = savedLanguage;
    }

    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }

    if (currentFbo) {
      config.headers.agency = currentFbo;
    }

    if (deviceId) {
      config.headers.DeviceId = deviceId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      removeFCMToken();
      removeUserToken();
      removeCurrentFbo();
      window.location.href = routes.public.login;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;